export enum LevelAssessmentButtonStatus {
    START_ASSESSMENT_BTN_ENABLED = "START_ASSESSMENT_BTN_ENABLED",
    // 버튼의 활성화 UI 여부 => 노출은 되지만 비활성화
    START_ASSESSMENT_BTN_DISABLED = "START_ASSESSMENT_BTN_DISABLED",
    // 버튼의 노출 여부
    START_ASSESSMENT_BTN_NON_EXPOSED = "START_ASSESSMENT_BTN_NON_EXPOSED",
    // start, retake 공통 사용
    CONTINUE_ASSESSMENT_ENABLED = "CONTINUE_ASSESSMENT_ENABLED",
    RETAKE_BTN_NON_EXPOSED = "RETAKE_BTN_NON_EXPOSED",
    RETAKE_BTN_EXPOSED = "RETAKE_BTN_EXPOSED",
    SEE_ANSWER_BTN_EXPOSED = "SEE_ANSWER_BTN_EXPOSED",
    SEE_ANSWER_BTN_NON_EXPOSED = "SEE_ANSWER_BTN_NON_EXPOSED"
}